import { Link } from "react-router-dom";

const BreadCrumb = ({ list }) => {
    const breadcrumbStyle = {
        "--bs-breadcrumb-divider": "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='currentColor'/%3E%3C/svg%3E\")",
    };
    return (
        <div className="menuBread">
            <nav style={breadcrumbStyle} aria-label="breadcrumb">
                <ol className="breadcrumb">
                    {
                        list.map((item, index) => {
                            return (
                                <li key={index} className={(index + 1 === list.length) ? 'breadcrumb-item active' :"breadcrumb-item"}>
                                    {
                                        item.url ?
                                            <Link to={item.url}>{item.name}</Link>
                                            :
                                            <span>{item.name}</span>
                                    }

                                </li>
                            )
                        })
                    }
                    {/* <li className="breadcrumb-item"><a href="#">Home</a></li>
                    <li className="breadcrumb-item" aria-current="page">New Zealand</li>
                    <li className="breadcrumb-item active" aria-current="page">South Island</li> */}
                </ol>
            </nav>
        </div>
    )
}
export default BreadCrumb;